import React from 'react';
import './CondomínioSelector.css';

/**
 * CondomínioSelector - Dropdown para seleção de condomínio (multi-tenant)
 * 
 * Comportamento:
 * - Aparece apenas se usuário tem acesso a 2+ condomínios
 * - Posicionado à direita do PageHeader
 * - Ao mudar: (1) atualiza Context, (2) refetch automático dispara em SideMenu
 * 
 * Props:
 * - condominios: array [{id, nome}, ...]
 * - activeCondominio: string - ID do condomínio ativo
 * - onChange: function - Callback(novoCondominioId)
 */
const CondomínioSelector = ({ condominios = [], activeCondominio, onChange }) => {
  const handleChange = (event) => {
    const novoCondominioId = event.target.value;
    if (onChange) {
      onChange(novoCondominioId);
    }
  };

  return (
    <div className="condominio-selector">
      <select 
        id="condominio-select"
        className="condominio-selector__dropdown"
        value={String(activeCondominio) || ''}
        onChange={handleChange}
      >
        {condominios.map((condominio, index) => (
          <option key={condominio.id || index} value={String(condominio.id)}>
            Condomínio {condominio.nome}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CondomínioSelector;
